import { render, staticRenderFns } from "./DetailProfile.vue?vue&type=template&id=1a5006c8"
import script from "./DetailProfile.vue?vue&type=script&lang=js"
export * from "./DetailProfile.vue?vue&type=script&lang=js"
import style0 from "./DetailProfile.vue?vue&type=style&index=0&id=1a5006c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports